import React, { useEffect, useState } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { useGetAllOfferDetailMutation } from "../../redux/services/offerApi";
import { selectData, selectJwtToken } from "../../redux/slices/authSlice";
import { getOffer, setOffer } from "../../redux/slices/offerSlice";
import clearIcon from "../../assets/Cancel.png";


type Props = {
  route: any;
  couponApply: any;
  amount: any;
  appliedOffer: any;
  closeModal: any;
  parkingLocationId: any;
};
const ApplyPromoCode = (props: Props) => {
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const [getAllOfferDetail, getAllOfferDetailResponse] =
    useGetAllOfferDetailMutation();
  const getOfferData = useAppSelector(getOffer);
  const [offersData, setOffersData] = useState([]);
  const dispatch = useAppDispatch();
  const userData: any = useSelector(selectData);
  const { parkingSpaceLocationId } = props.route;
  useEffect(() => {
    if (getOfferData) {
      setOffersData(getOfferData);
    }
  }, [getOfferData]);
  useEffect(() => {
    getAllOfferDetail({
      token: token,
      payload: {
        page: 0,
        orderBy: "id",
        offset: 1000,
        parkingSpaceLocationId: props.parkingLocationId,
        customerId: userData.customerId,
      },
    });
  }, []);
  useEffect(() => {
    if (getAllOfferDetailResponse.isSuccess) {
      dispatch(setOffer(getAllOfferDetailResponse.data));
    }
  }, [getAllOfferDetailResponse.isSuccess]);


  return (
    <div className="p-4 md:p-6">
      <div className="flex justify-end -mt-4 md:-mt-6">
        <button
          type="button"
          aria-label="Close"
          onClick={(event) => props.closeModal(event)}
        >
          <img src={clearIcon} className="cursor-pointer w-5 h-5" />
        </button>

      </div>
      <p className="text-center font-bold text-[#58595B] text-lg md:text-2xl">
        Apply Coupons
      </p>
      {offersData?.length === 0 && (
        <div className="font-bold text-[#58595B] text-center text-base md:text-lg mt-4">
          No coupons available.
        </div>
      )}
      {offersData?.map((response: any, index: any) => (
        <div key={index} className="flex flex-col md:flex-row items-center my-4">
          <div className="flex shadow-md w-full">
            {/* Offer Value Section */}
            <div className="bg-[#ED1C24] w-1/3 text-center rounded-md flex items-center justify-center p-2">
              <p className="text-white font-bold text-2xl md:text-3xl leading-tight">
                <span className="block">
                  {response.offerType !== "OTPRCNT" ? "₹" : ""}
                  {response.offerValue}
                  {response.offerType === "OTPRCNT" ? "%" : ""}
                </span>
                <span className="block">OFF</span>
              </p>
            </div>
            {/* Offer Details Section */}
            <div className="flex flex-1 flex-col justify-between bg-white p-2  rounded-md">
              <p className="text-[#58595B] font-bold text-base">{response.promoCode}</p>
              <p className="text-[#58595B] text-sm md:text-base font-medium mt-1">
                {response.offerTitle}
              </p>
              <div className="flex justify-end">
                {props.appliedOffer?.id === response.id ? (
                  <p className="text-green-500 font-bold text-base md:text-lg">APPLIED</p>
                ) : (
                  <button
                    type="button"
                    className={`font-bold text-base md:text-lg ${response.offerType === "OTFLT" &&
                        parseFloat(props.amount) < parseFloat(response.offerValue)
                        ? "text-gray-400 cursor-not-allowed"
                        : "text-[#ED1C24] cursor-pointer"
                      }`}
                    onClick={() =>
                      response.offerType === "OTFLT" &&
                        parseFloat(props.amount) < parseFloat(response.offerValue)
                        ? null
                        : props.couponApply(false, response)
                    }
                  >
                    APPLY
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
export default ApplyPromoCode;
